/* cb-faq.js - Help & FAQ-pagina (redesign 2026)
   Accordeon, live zoeken, deeplinks en scroll-spy. Alles client-side over de
   vragen die al in de HTML staan: niets wordt bijgeladen, want het antwoord
   moet in de DOM blijven staan voor Google. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cb-faq]');
  if (!root) { return; }

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-cb-faq-row]'));
  var cats = Array.prototype.slice.call(root.querySelectorAll('[data-cb-faq-cat]'));
  var searchInput = root.querySelector('[data-cb-faq-search]');
  var searchClear = root.querySelector('[data-cb-faq-search-clear]');
  var noResults = root.querySelector('[data-cb-faq-noresults]');
  var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-cb-faq-navlink]'));

  /* ================= Accordeon ================= */

  function setOpen(row, open) {
    var btn = row.querySelector('[data-cb-faq-toggle]');
    row.classList.toggle('is-open', open);
    if (btn) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  }

  // Gedelegeerd, zodat het ook werkt als de theme-editor de sectie hertekent.
  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-faq-toggle]');
    if (!btn || !root.contains(btn)) { return; }
    var row = btn.closest('[data-cb-faq-row]');
    if (!row) { return; }
    setOpen(row, !row.classList.contains('is-open'));
  });

  /* ================= Zoeken =================
   * Vergelijkt op vraag en antwoord samen: wie "pakket kwijt" typt zoekt op
   * woorden die in het antwoord staan, niet in de vraag.
   */

  function normalise(value) {
    var text = (value || '').toLowerCase();
    // Diakrieten weg, zodat "geld terug" ook "géld terug" vindt.
    if (text.normalize) { text = text.normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    return text.replace(/\s+/g, ' ').trim();
  }

  // Eenmalig de zoektekst per rij klaarzetten; dat scheelt werk per toetsaanslag.
  // De feedbackregel telt niet mee: "ja", "nee" en "nuttig" staan onder élk
  // antwoord en zouden anders op elke vraag matchen.
  rows.forEach(function (row) {
    var clone = row.cloneNode(true);
    var extras = clone.querySelectorAll('[data-cb-faq-helpful]');
    for (var i = 0; i < extras.length; i++) { extras[i].parentNode.removeChild(extras[i]); }
    row.__cbText = normalise(clone.textContent);
  });

  function clearFilter() {
    rows.forEach(function (row) { row.hidden = false; });
    cats.forEach(function (cat) { cat.hidden = false; });
    if (noResults) { noResults.hidden = true; }
  }

  function applyFilter(term) {
    var q = normalise(term);

    if (!q) {
      clearFilter();
      return;
    }

    var hits = 0;

    rows.forEach(function (row) {
      var match = row.__cbText.indexOf(q) !== -1;
      row.hidden = !match;
      if (match) {
        hits++;
        // Wie zoekt wil het antwoord zien, niet nog een keer klikken.
        setOpen(row, true);
      }
    });

    // Een categoriekop zonder overgebleven vragen is alleen maar ruis.
    cats.forEach(function (cat) {
      var zichtbaar = cat.querySelectorAll('[data-cb-faq-row]:not([hidden])').length;
      cat.hidden = zichtbaar === 0;
    });

    if (noResults) { noResults.hidden = hits > 0; }
  }

  if (searchInput) {
    var timer = null;
    searchInput.addEventListener('input', function () {
      if (searchClear) { searchClear.hidden = searchInput.value.length === 0; }
      // Kort wachten: bij lange lijsten scheelt dat werk tijdens het typen.
      clearTimeout(timer);
      timer = setTimeout(function () { applyFilter(searchInput.value); }, 120);
    });
    // Escape wist de zoekopdracht, zoals in elk zoekveld.
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchInput.value) {
        e.preventDefault();
        searchInput.value = '';
        if (searchClear) { searchClear.hidden = true; }
        clearFilter();
      }
    });
  }

  if (searchClear && searchInput) {
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchClear.hidden = true;
      clearFilter();
      searchInput.focus();
    });
  }

  /* ================= Feedback ("was dit nuttig?") =================
   * Eén stem per antwoord per paginabezoek; genoeg voor een signaal, geen
   * opslag nodig. Het event gaat de dataLayer in en Tag Manager bepaalt wat
   * ermee gebeurt. Bewust geen gtag(): dat global bestaat hier niet, de site
   * laadt GA4 via de GTM-container.
   */

  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-faq-vote]');
    if (!btn || !root.contains(btn)) { return; }
    var wrap = btn.closest('[data-cb-faq-helpful]');
    if (!wrap || wrap.classList.contains('is-voted')) { return; }

    wrap.classList.add('is-voted');
    btn.classList.add('is-chosen');
    var thanks = wrap.querySelector('[data-cb-faq-thanks]');
    if (thanks) { thanks.hidden = false; }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'faq_feedback',
      event_category: 'FAQ',
      event_label: wrap.getAttribute('data-cb-faq-question') || '',
      value: btn.getAttribute('data-cb-faq-vote') === 'yes' ? 1 : 0
    });
  });

  /* ================= Deeplinks =================
   * Een link naar #verzending moet niet alleen scrollen maar ook meteen het
   * eerste antwoord tonen. Dat maakt de ankers bruikbaar vanaf de PDP, de
   * winkelwagen en de ordertracking.
   */

  function openFirstIn(anchor) {
    if (!anchor) { return null; }
    var cat = root.querySelector('[data-cb-faq-cat="' + (window.CSS && CSS.escape ? CSS.escape(anchor) : anchor) + '"]');
    if (!cat) { return null; }
    var first = cat.querySelector('[data-cb-faq-row]');
    if (first) { setOpen(first, true); }
    return cat;
  }

  root.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link || !root.contains(link)) { return; }
    var anchor = link.getAttribute('href').slice(1);
    if (!anchor) { return; }
    openFirstIn(anchor);
    // De browser doet het scrollen zelf; wij zorgen alleen dat het open staat.
  });

  function handleHash() {
    var anchor = (location.hash || '').slice(1);
    if (!anchor) { return; }
    var cat = openFirstIn(anchor);
    if (cat) {
      // Na het openklappen opnieuw richten: de hoogte is net veranderd.
      requestAnimationFrame(function () {
        cat.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    }
  }

  window.addEventListener('hashchange', handleHash);
  handleHash();

  /* ================= Scroll-spy (desktop) ================= */

  if (navLinks.length && cats.length && 'IntersectionObserver' in window) {
    var markActive = function (anchor) {
      navLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-cb-faq-navlink') === anchor);
      });
    };

    var zichtbaar = {};
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        zichtbaar[entry.target.getAttribute('data-cb-faq-cat')] = entry.isIntersecting;
      });
      // De bovenste die in beeld staat wint, zodat de markering meeloopt met
      // de leesrichting in plaats van te springen.
      for (var i = 0; i < cats.length; i++) {
        var naam = cats[i].getAttribute('data-cb-faq-cat');
        if (zichtbaar[naam]) { markActive(naam); return; }
      }
    }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });

    cats.forEach(function (cat) { spy.observe(cat); });
  }
})();
